import { Component, inject, OnInit, Signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngxs/store';
import { CoreSelectors } from '../state/core.selectors';
import { AppSessionsService } from './app-sessions.service';
import { GetAppConnectedSessions } from '../state/core.actions';


@Component({
  selector: 'app-sessions',
  templateUrl: './app-sessions.component.html',
  styleUrl: './app-sessions.component.scss',
  imports: [MatTooltipModule],
  providers:[AppSessionsService]
})
export class AppSessionsComponent implements OnInit {
 private _store = inject(Store);

 public appConnectedSessions: Signal<number> = this._store.selectSignal(CoreSelectors.getAppConnectedSessions);

ngOnInit(): void {
  this._store.dispatch(new GetAppConnectedSessions());
}

}
